<template>
    <Layout>
        <div slot="main" class="home-bg">
            <div class="vw-banner-area">
                <q-carousel
                    style="width: 100%;height:100%"
                    animated
                    v-model="bannerIndex"
                    infinite
                    autoplay
                    transition-prev="slide-right"
                    transition-next="slide-left"
                >
                    <q-carousel-slide
                        v-for="(banner, index) in bannerList"
                        :key="index"
                        :name="index"
                        :img-src="banner.src"
                        @click="bannerTo(banner)"
                    />
                </q-carousel>
            </div>
            <div v-for="(home, index) in homeList" :key="index">
                <div v-if="home.type === 'groupIntroduce'">
                    <div class="block intro-block">
                        <strong class="block-title">{{introTitle}}</strong>
                        <i class="block-title-line"></i>
                        <div class="vw-intro-slide">
                            <img :src="groupList[0]" alt="">
                        </div>
                        <div class="content intro-content editor-gen" v-html="introContent"></div>
                        <div class="more-row">
                            <span @click="goAboutIntro" class="btn-more">MORE<q-icon name="add"></q-icon></span>
                        </div>
                    </div>
                </div>
                <div v-if="home.type === 'safeService'">
                    <div class="block company-block">
                        <strong class="block-title">{{newsTitle}}</strong>
                        <i class="block-title-line"></i>
                        <dl v-for="news in newsList" :key="news.newsId" @click="goDetail(news)">
                            <dt class="company-text">{{isCn?news.titleChina:news.titleEng}}</dt>
                            <dd class="company-photo">
                                <img class="vw-img" :src="news.image" alt="">
                            </dd>
                        </dl>
                        <div class="more-row">
                            <router-link :to="{name: 'newsList'}" class="btn-more">MORE<q-icon name="add"></q-icon></router-link>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </layout>
</template>

<script>
import ajax from '@/utils/ajax';
import Layout from '@/views/Layout.vue';
import { gDate } from '@/utils/format';

export default {
    name: 'home',
    components: {
        Layout,
    },
    data() {
        return {
            isCn: window.localStorage.getItem('show-lang') !== 'en',
            homeList: [],
            bannerIndex: 0,
            bannerList: [],
            introTitle: '',
            introContent: '',
            groupList: [],
            serviceList: [],
            safeServiceTitle: '',
            serviceIndex: 2,
            serviceMarginIndex: 0,
            newsTitle: '',
            newsList: [],
        };
    },
    computed: {
        serviceTrans() {
            const screenWidth = window.innerWidth;
            return `${-this.serviceIndex * 278 * screenWidth / 375}px`;
        },
        serviceMargin() {
            const screenWidth = window.innerWidth;
            return `${-(this.serviceMarginIndex * 278 - 45) * screenWidth / 375}px`;
        },
    },
    mounted() {
        const self = this;
        ajax.get('/web/homepage/homepage_list.json', {}).then((result) => {
            self.homeList = result.dataList;
            result.dataList.forEach((value) => {
                const bannerList = [];
                let jsonObj = null;
                try {
                    jsonObj = JSON.parse(value.jsonStr);
                    if (value.type === 'banner') {
                        jsonObj.forEach((v) => {
                            bannerList.push({
                                src: v.bannerH5Img,
                                link: v.bannerLink,
                            });
                        });
                        self.bannerList = bannerList;
                    }
                    if (value.type === 'safeService') {
                        this.newsTitle = self.isCn ? jsonObj.titleCn : jsonObj.titleEn;
                    }
                    if (value.type === 'groupIntroduce') {
                        self.introTitle = self.isCn ? jsonObj.titleCn : jsonObj.titleEn;
                        self.introContent = self.isCn ? jsonObj.contentCn : jsonObj.contentEn;
                        self.groupList = jsonObj.groupImages;
                    }
                } catch (e) {
                    console.log('json error');
                }
            });
        }).catch(() => {});
        ajax.get('/web/news/news_list.json', { pageSize: 5 }).then((result) => {
            this.newsList = result.dataList.map((v) => {
                v.pubTime = gDate.datetimeFormat(v.pubTime, 'YYYY-MM-DD');
                v.cnBriefIntro = v.cnBriefIntro.length > 100 ? `${v.cnBriefIntro.substr(0, 100)} ...` : v.cnBriefIntro;
                v.enBriefIntro = v.cnBriefIntro.length > 200 ? `${v.cnBriefIntro.substr(0, 200)} ...` : v.enBriefIntro;
                v.titleChina = v.titleChina.length > 50 ? `${v.titleChina.substr(0, 50)} ...` : v.titleChina;
                v.titleEng = v.titleEng.length > 100 ? `${v.titleEng.substr(0, 100)} ...` : v.titleEng;
                return v;
            });
        }).catch(() => {});
        this.introContent = '';
    },
    methods: {
        goAboutIntro() {
            ajax.get('/web/common/navigate_list.json', { documentUrl: 'about' }).then((result) => {
                let index = 0;
                result.data.sonNavigateList.forEach((v, i) => {
                    if (v.documentUrl === 'aboutIntro') {
                        index = i;
                    }
                });
                this.$router.push({ name: 'about', hash: `#${index}` });
            }).catch(() => {});
        },
        serviceSwipe({ evt, ...info }) {
            // let index = this.serviceIndex;
            if (info.direction === 'left') {
                this.serviceIndex += 1;
                setTimeout(() => {
                    this.serviceList.push(this.serviceList.shift());
                    this.serviceMarginIndex -= 1;
                }, 450);
            } else if (info.direction === 'right') {
                this.serviceIndex -= 1;
                setTimeout(() => {
                    this.serviceList.unshift(this.serviceList.pop());
                    this.serviceMarginIndex += 1;
                }, 450);
            }
        },
        bannerTo(banner) {
            if (banner.link) {
                document.location.href = banner.link;
            }
        },
        goDetail(news) {
            this.$router.push({ name: 'newsDetail', params: { id: news.newsId } });
        },
    },
};
</script>
<style lang="less" scoped>
    .home-bg {
        background: #F1F1F1;
    }
    .vw-banner-area {
        width: 100%;
        height: 214px;
    }
    .block {
        margin-top: 10px;
        background: #fff;
        padding: 15px 0;
        .block-title {
            display: block;
            padding-top: 8px;
            font-size: 14px;
            font-weight: 600;
            text-align: center;
        }
        .block-title-line {
            margin-top: 6px;
            display: block;
            margin: 0 auto;
            width: 22px;
            height: 2px;
            background: #C71F4B;
        }
    }
    .vw-intro-slide {
        margin: 10px auto;
        width: 345px;
        img {
            display: block;
            margin: 0 auto;
            width: 160px;
            height: auto;
        }
    }
    .more-row {
        padding-top: 16px;
        text-align:center;
        .btn-more {
            display: inline-flex;
            justify-content: center;
            align-items: center;
            width: 90px;
            height: 28px;
            line-height: 28px;
            font-size: 12px;
            color: #4A4A4A;
            border: 1px solid #C71F4B;
        }
    }
    .vw-service-slide {
        margin-top: 10px;
        height: 202.5px;
        .service-photo-area {
            transition: transform 0.4s linear;
            display: flex;
            justify-content: flex-start;
            align-items: flex-end;
            flex-wrap: nowrap;
            width: auto;
            height: 100%;
            margin-left: 40px;
            li {
                position: relative;
                flex: 0 0 270px;
                width: 270px;
                height: 202.5px;
                margin: 0 4px;
                .service-text {
                    position: absolute;
                    left: 0;
                    bottom: 0;
                    height: 38px;
                    width: 100%;
                    line-height: 38px;
                    background: rgba(0,0,0,.65);
                    font-size: 12px;
                    color: #fff;
                    text-align: center;
                    text-overflow: ellipsis;
                    white-space: nowrap;
                    overflow: hidden;
                }
                img {
                    width: 100%;
                    height: 100%;
                }
                &.back-end {
                    filter: blur(2px);
                }
            }
        }
    }
    .company-block {
        padding: 15px;
        .company-text {
            margin-top: 10px;
            font-size: 13px;
            line-height: 20px;
            padding: 2px 0;
            word-break: break-word;
        }
        .company-photo {
            padding-bottom: 12px;
            border-bottom: 1px solid #F1F1F1;
            width: 100%;
            .vw-img {
                margin: 0 auto;
                display: block;
                width: 345px;
                height: 133.4px;
            }
        }
    }
</style>
